export enum UserType {
  INDIVIDUAL = 1,
  ENTERPRISE = 2
}

export interface UserInfoMap {
  mid: number
  custId: number
  userNo: number
}
export interface UserLoginResponse {
  accountFlag: boolean
  digisignFlag: boolean
  cookieToken: string
  tenantId: number
  email: string
  loginKey: string
  loginName: string
  mobile: string
  step: number
  userId: number
  userInfoMap: UserInfoMap
  userName: string
  userNo: number
  userType: number
}
